import './index.scss'
import Rails from '@rails/ujs'
import I18n from '../../../javascript/i18n/index.js.erb'
import { Controller as BaseController } from 'stimulus'

export class Controller extends BaseController {
  static targets = ['self', 'issues']
  static classes = ['editing']

  connect() {
    const loaded = this.data.get('loaded')
    if (loaded === 'true') return

    this.issuesTarget.innerHTML = `<h2>${I18n.t('template.issues.loading')}</h2>`

    this.fetchIssues()
  }

  edit(event) {
    this.selfTarget.classList.add(event.currentTarget.dataset.editingClass)
    this.selfTarget.classList.add(this.editingClass)
  }

  cancel() {
    this.fetchIssues()
  }

  fetchIssues() {
    Rails.ajax({
      type: 'GET',
      dataType: 'script',
      url: this.data.get('url'),
      data: $.param({
        issues_element_id: this.selfTarget.id
      }),
      error: () => {
        this.selfTarget.innerHTML = `<h2>${I18n.t('template.issues.load_failure')}</h2>`
      }
    })
  }
}
